import ModalForm from '../../../shared/components/modal-form';

export default class MentorDisponibilityForm extends ModalForm {
  constructor() {
    super(...arguments);

    this.$availableInput = this.$element.find('#mentorAvailable');
    this.$unavailableInput = this.$element.find('#mentorUnavailable');
    this.$datepickerInputs = this.$element.find(
      '.mentorDisponibilityForm-dates-datepicker'
    );

    this.$menteeshipLimitCheckbox = this.$element.find('#menteeshipLimit');
    this.$menteeshipLimitLabel = this.$element.find(
      '.modalForm-group-label--menteeshipLimit'
    );
    this.$menteeshipLimitInput = this.$element.find(
      '.modalForm-group-input--menteeshipLimit'
    );

    this.bindEvents();
  }

  bindEvents() {
    this.handleDatePickerHide = this.handleDatePickerHide.bind(this);
    this.handleDatePickerShow = this.handleDatePickerShow.bind(this);
    this.handleAvailabilityChange = this.handleAvailabilityChange.bind(this);
    this.handleUnavailabilityChange = this.handleUnavailabilityChange.bind(
      this
    );
    this.handleMenteeshipLimitCheckboxChange = this.handleMenteeshipLimitCheckboxChange.bind(
      this
    );

    this.$datepickerInputs.on(
      'hide.mentorDisponibilityForm',
      this.handleDatePickerHide
    );
    this.$datepickerInputs.on(
      'show.mentorDisponibilityForm',
      this.handleDatePickerShow
    );

    this.$availableInput.on(
      'change.mentorDisponibilityForm',
      this.handleAvailabilityChange
    );
    this.$unavailableInput.on(
      'change.mentorDisponibilityForm',
      this.handleUnavailabilityChange
    );

    this.$menteeshipLimitCheckbox.on(
      'change.mentorDisponibilityForm',
      this.handleMenteeshipLimitCheckboxChange
    );

    if (this.$element.hasClass('modal')) {
      super.bindEvents(...arguments);
    }
  }

  unbindEvents() {
    this.$datepickerInputs.off(
      'hide.mentorDisponibilityForm',
      this.handleDatePickerHide
    );
    this.$datepickerInputs.off(
      'show.mentorDisponibilityForm',
      this.handleDatePickerShow
    );
    this.$availableInput.off(
      'change.mentorDisponibilityForm',
      this.handleAvailabilityChange
    );
    this.$unavailableInput.off(
      'change.mentorDisponibilityForm',
      this.handleUnavailabilityChange
    );
    this.$menteeshipLimitCheckbox.off(
      'change.mentorDisponibilityForm',
      this.handleMenteeshipLimitCheckboxChange
    );

    if (this.$element.hasClass('modal')) {
      super.unbindEvents(...arguments);
    }
  }

  handleDatePickerShow() {
    this.$unavailableInput.prop('checked', true);
  }

  handleDatePickerHide() {
    if (this.$unavailableInput.prop('checked')) {
      this.$datepickerInputs.each((_index, input) => {
        if ($(input).val() === '') {
          $(input).datepicker('show');
          return false;
        } else {
          $(input).datepicker('hide');
        }
      });
    }
  }

  handleAvailabilityChange() {
    this.$datepickerInputs.val('');
    this.$datepickerInputs.datepicker('hide');
  }

  handleUnavailabilityChange() {
    this.$datepickerInputs.first().datepicker('show');
  }

  handleMenteeshipLimitCheckboxChange() {
    if (this.$menteeshipLimitCheckbox.prop('checked')) {
      this.$menteeshipLimitLabel.removeClass('modalForm-group-label--inactive');
      this.$menteeshipLimitInput.prop('disabled', false);
      this.$menteeshipLimitInput.focus();
    } else {
      this.$menteeshipLimitLabel.addClass('modalForm-group-label--inactive');
      this.$menteeshipLimitInput.prop('disabled', true);
    }
  }

  handleModalHide(event) {
    // Only reload the window if the modal has been closed, not any component within itself (like the datepicker)
    if (this.formWasSuccessful && event.target === this.$element[0]) {
      window.Turbolinks.reload();
    }
  }

  handleFormSuccess() {
    this.formWasSuccessful = true;
    this.$element.modal('hide');
  }
}
